const USER_ROLE_BASIC = 2;
const USER_ROLE_QA = 4;
const USER_ROLE_DEV = 8;

export const isDev = (role: number) => {
  return Boolean(role & USER_ROLE_DEV);
};

export const isQA = (role: number) => {
  return Boolean(role & USER_ROLE_QA);
};

export const isBlocked = (role: number) => {
  return !(role & USER_ROLE_BASIC);
};
